/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  accessActions,
  attendanceActions,
  authActions,
  userActions
} from "../../../redux/actions";
import Button from "../../../component/button/Button";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import P from "../../../component/smallComponents/P";
import SelectInput from "../../../component/input/SelectInput";
import { renderAccessLocation } from "../../../constant/helper/helper";

const SelectLocationPage = () => {
  const localStorageLocationName = localStorage.locationName;
  const localStorageModuleType = localStorage.moduleType;
  const localStorageLocationId = localStorage.locationId;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onLogoutPress = () => {
    dispatch(userActions.unmountAllUsersData());
    dispatch(attendanceActions.unmountAttendanceData());
    dispatch(authActions.logoutUser());
  };

  const [selectLocation, setSelectLocation] = useState("");
  const [locationName, setLocationName] = useState("");
  const [moduleType, setModuleType] = useState("");
  const [locationId, setLocationId] = useState("");
  const [employeeAccess] = useState(
    JSON.parse(localStorage.employeeAccess)
  );

  const { isAuthenticated, currentUser } = useSelector(
    (state) => state.auth
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    localStorage.setItem("locationName", locationName);
    localStorage.setItem("moduleType", moduleType);
    localStorage.setItem("locationId", locationId);
    localStorage.setItem("initialRendering", true);
    const localStorageLocationName = await localStorage.locationName;
    const localStorageModuleType = await localStorage.moduleType;
    const localStorageLocationId = await localStorage.locationId;
    dispatch(accessActions.selectedModuleAccess(selectLocation));
    const selectedModule = employeeAccess.filter((filterModule) => {
      return (
        filterModule.locationId
          .toLowerCase()
          .indexOf(locationId.toLowerCase()) !== -1
      );
    });
    localStorage.setItem(
      "selectedModule",
      JSON.stringify(selectedModule)
    );
    if (
      isAuthenticated &&
      localStorageLocationName !== "" &&
      localStorageModuleType !== "" &&
      localStorageLocationId !== "" &&
      typeof localStorageLocationName !== "undefined" &&
      typeof localStorageLocationId !== "undefined" &&
      typeof localStorageModuleType !== "undefined"
    ) {
      navigate(
        `/dashboard/${currentUser.workerFirstName}/${currentUser.workerDepartment}`
      );
    }
  };

  useEffect(() => {
    dispatch(authActions.clearAuthErrors());
    dispatch(authActions.clearAuthResult());
    dispatch(authActions.setAuthLoading(false));
    return () => {
      dispatch(authActions.clearAuthErrors());
      dispatch(authActions.clearAuthResult());
      dispatch(authActions.setAuthLoading(false));
    };
  }, []);

  useEffect(() => {
    if (
      isAuthenticated &&
      localStorageLocationName !== "" &&
      localStorageModuleType !== "" &&
      typeof localStorageLocationName !== "undefined" &&
      typeof localStorageModuleType !== "undefined"
    ) {
      navigate(
        `/dashboard/${currentUser.workerFirstName}/${currentUser.workerDepartment}`
      );
    }
  }, [
    localStorageLocationName,
    localStorageModuleType,
    isAuthenticated,
    localStorageLocationId
  ]);

  const onSelectLocation = (e) => {
    const { value } = e.target;
    setSelectLocation(value);
    employeeAccess.filter((employeeData, i) => {
      const checkModuleOfEmployee =
        employeeData.locationId + " / " + employeeData.moduleType;
      if (checkModuleOfEmployee === value) {
        setLocationName(employeeData.locationName);
        setModuleType(employeeData.moduleType);
        setLocationId(employeeData.locationId);
      }
    });
  };

  return (
    <div className="authentication-bg">
      <div className="account-pages mt-5 mb-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="card">
                <div className="card-header pt-4 text-center bg-dark">
                  <span>
                    <img
                      src="https://i.imgur.com/ahvlkuu.png"
                      alt=""
                      height="35"
                    />
                  </span>
                </div>
                <div className="card-body p-4 bg-dark">
                  <div className="text-center w-75 m-auto">
                    <HeaderTag
                      type="h4"
                      title="Select Project"
                      isClassName={true}
                      className="text-white text-center mt-0 font-weight-bold"
                    />
                    <P title="Please Select Your Project to Access Dashboard" />
                  </div>
                  <form onSubmit={onSubmit}>
                    <SelectInput
                      required={true}
                      textWhite={true}
                      isLabeled={true}
                      value={selectLocation}
                      label="Select Project"
                      onChange={onSelectLocation}
                    >
                      {renderAccessLocation(employeeAccess)}
                    </SelectInput>
                    <div className="form-group mb-0 text-center mt-3">
                      <Button
                        title="Submit"
                        icon="mdi mdi-login"
                        type="submit"
                        isBackgroundColor={true}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="text-center w-75 m-auto">
              <P
                title="This site is available for Authorized users. If you
                      are not authorized user, please  don't attempt to
                      login. All activities performed on this site are
                      logged and monitored."
              />
              <div className="form-group mb-0 text-center mt-3">
                <Button
                  title="LOGOUT"
                  icon="mdi mdi-login"
                  type="button"
                  onClick={onLogoutPress}
                  isBackgroundColor={false}
                  className="btn btn-dark"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer footer-alt">
        <p>
          Developed and maintain by{" "}
          <strong className="text-dark">
            VITORSCAPE Copyright ©
          </strong>
        </p>
        {/* <p>
          Copyright ©{" "}
          <strong className="text-dark">VITORSCAPE</strong>
        </p> */}
      </footer>
    </div>
  );
};

export default SelectLocationPage;
